import { makeStyles } from '@material-ui/core/styles';
import { COLORS, DIMENSIONS, SPACING } from '../../styles/constants';

export const useStyles = makeStyles({
	main: {
		minHeight: `calc(100vh - ${DIMENSIONS.NAVBAR_HEIGHT}px)`,
		backgroundColor: COLORS.BACKGROUND,
		width: '100%',
		height: '100%'
	}
});

export const useWithBreadcrumbsStyles = makeStyles(theme => ({
	pagePadding: {
		padding: `0
                  ${theme.spacing(SPACING)}px
                  0
                  ${theme.spacing(SPACING)}px`
	},
	title: {
		'& .MuiTypography-root': {
			color: theme.palette.text.primary,
			fontWeight: 600
		},
		marginTop: 60
	},
	categoryTitle: {
		'& .MuiTypography-root': {
			color: theme.palette.text.primary,
			fontWeight: 600
		},
		marginTop: 80
	}
}));
